import { TypeOrUndefined } from '../models/generics'

export const filterUndefined = <T>(ts: ReadonlyArray<TypeOrUndefined<T>>): ReadonlyArray<T> =>
  ts.filter((t: TypeOrUndefined<T>): t is T => !!t)
